import { simpleGlobalState } from './SimpleGlobalState';

export const useIsInSuspense = simpleGlobalState(false);

export const useViewDocumentTrainingRecords = simpleGlobalState(false);
